import React, { FC } from 'react';

import { Notification as NotificationModel } from 'api-client';
import { formatDate, formatTime } from 'formatters';

import NotificationBadges from '../NotificationBadges';
import NotificationContent from '../NotificationContent';
import NotificationFile from '../NotificationFile';
import styles from './Notification.module.scss';

interface Props {
  notification: NotificationModel;
}

const Notification: FC<Props> = ({ notification }) => (
  <article className={styles.card}>
    <div className={styles.head}>
      <NotificationBadges notification={notification} />
      <div className={styles.date}>
        <span>{formatDate(notification.createdAt)}</span>
        <span>{formatTime(notification.createdAt, 'hh:mm')}</span>
      </div>
    </div>

    <NotificationContent notification={notification} />

    {notification.file !== undefined && <NotificationFile file={notification.file} />}
  </article>
);

export default Notification;
